export const ALL_PROJECT_REQUEST = "ALL_PROJECT_REQUEST";
export const ALL_PROJECT_SUCCESS = "ALL_PROJECT_SUCCESS";
export const ALL_PROJECT_FAIL = "ALL_PROJECT_FAIL";

export const ALL_REQUEST_REQUEST = "ALL_REQUEST_REQUEST";
export const ALL_REQUEST_SUCCESS = "ALL_REQUEST_SUCCESS";
export const ALL_REQUEST_FAIL = "ALL_REQUEST_FAIL";

export const ADD_PROJECT_REQUEST = "ADD_PROJECT_REQUEST";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_FAIL = "ADD_PROJECT_FAIL";

export const DONATE_REQUEST = "DONATE_REQUEST";
export const DONATE_SUCCESS = "DONATE_SUCCESS";
export const DONATE_FAIL = "DONATE_FAIL";

export const APPROVE_REQUEST = "APPROVE_REQUEST";
export const APPROVE_SUCCESS = "APPROVE_SUCCESS";
export const APPROVE_FAIL = "APPROVE_FAIL";

export const FINALIZE_REQUEST = "FINALIZE_REQUEST";
export const FINALIZE_SUCCESS = "FINALIZE_SUCCESS";
export const FINALIZE_FAIL = "FINALIZE_FAIL";

export const ADD_REQUEST_REQUEST = "ADD_REQUEST_REQUEST";
export const ADD_REQUEST_SUCCESS = "ADD_REQUEST_SUCCESS";
export const ADD_REQUEST_FAIL = "ADD_REQUEST_FAIL";

export const PROJECT_DETAILS_REQUEST = "PROJECT_DETAILS_REQUEST";
export const PROJECT_DETAILS_SUCCESS = "PROJECT_DETAILS_SUCCESS";
export const PROJECT_DETAILS_FAIL = "PROJECT_DETAILS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
